import React from "react";

export interface TitleInputProps
    extends Omit<
        React.ComponentProps<"input">,
        "value" | "onChange" | "className"
    > {
    /** The current title value (controlled). */
    value: string;
    /** Fired with the next value on each keystroke. */
    onChange: (next: string) => void;
    /** Names the field for assistive tech; there is no visible label. */
    "aria-label": string;
}

/**
 * A page title typed in place: a bordered field sized to hold a long name,
 * the input in the bold display size of a page title. The construction the
 * Programs draft header introduced (`ProgramNameField`, which now composes
 * this), shared so every "name it as you create it" header reads the same:
 * the draft Program title and the Add Member page's member name.
 *
 * Pure controlled View: value in, change out.
 */
export function TitleInput({
    value,
    onChange,
    ...inputProps
}: TitleInputProps): React.ReactElement {
    return (
        // why: w-[26rem] sizes the field to a long name without pushing a
        // status badge beside it to the edge (the Programs draft header).
        <div className="flex items-center h-12 w-[26rem] max-w-full border border-line-base bg-transparent px-3">
            <input
                {...inputProps}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="flex-1 min-w-0 bg-transparent outline-none font-sans font-bold text-2xl text-foreground-base placeholder:text-foreground-neutral placeholder:font-normal"
            />
        </div>
    );
}
